module.exports = __webpack_public_path__ + "img/edit.e65150a6.svg";